const releasesES = {
    "view": {
        "table": {
            "title": "Lista de tus lanzamientos",
            "column": {
                "name": "Nombre",
                "artist": "Artista",
                "catalogue_number": "Núm. Cat.",
                "release_date": "Fecha de lanzamiento",
                "status": "Estado",
                "store_urls": "URLs de la tienda",
                "qc": "QC",
                "pre_scan": "Pre-Escaneo",
                "alert": "Alerta",
                "flagged": "Marcado",
                "action": "Acción"
            },
            "label": {
                "status_ready": "Listo",
                "status_approval": "En cola de envío",
                "status_takedown_request": "Solicitud de retirada",
                "status_taken_down": "Retirado",
                "status_distributed": "Distribuido",
                "status_locked": "En progreso - Bloqueado",
                "status_delivering": "Entregando",
                "status_unlocked": "Por favor edita",
                "status_offline": "Desconectado",
                "status_re_delivery-delivery": "Re-entrega",
                "status_re_delivery-editing": "Edición de re-entrega",
                "status_unknown": "Estado desconocido"
            },
            "button": {
                "export_csv": "Exportar CSV"
            },
            "placeholder": {
                "search": "Buscar..."
            },
            "dropdown": {
                "item": {
                    "action": "Acción",
                    "distribute": "Distribuir",
                    "viewRelease": "Ver lanzamiento",
                    "editReleaseMetadata": "Editar metadatos del lanzamiento",
                    "editTracks": "Editar pistas",
                    "takedown": "Retirar",
                    "submitEditing": "Enviar edición",
                    "deliveredList": "Lista entregada",
                    "copyEanUpc": "Copiar EAN/UPC"
                },
                "message": {
                    "submitInformationTooltip": "Aún no has proporcionado tu información completa, por lo tanto, no puedes distribuir los lanzamientos. Para hacerlo, por favor envía tu información.",
                    "submitMetadataTooltip": "Por favor envía los metadatos de todas las pistas para poder distribuir el lanzamiento.",
                    "submitEditingMetadataTooltip": "Por favor envía los metadatos de todas las pistas para poder enviar las ediciones.",
                    "submitEditingTokenRequiredTooltip": "Se requiere al menos 1 token para enviar la edición para la re-entrega. <2>Pedir tokens</2>.",
                    "blacklistedArtistTooltip": "Este lanzamiento no puede ser distribuido ya que contiene una o más pistas de un artista blacklisted. Por favor contacta a nuestro equipo de soporte para más información.",
                    "distributionDisabledPreScanInProgress": "Por favor espera a que el pre-escaneo se complete primero para poder distribuir el lanzamiento.",
                    "distributionDisabledPreScanNotDone": "Por favor realiza el pre-escaneo primero para poder distribuir el lanzamiento.",
                    "distributionDisabledPreScanDeclarationNotSubmitted": "Por favor envía la declaración del pre-escaneo primero para poder distribuir el lanzamiento.",
                },
                "modal": {
                    "editMetadata": {
                        "header": "¿Estás realmente seguro de que quieres editar los metadatos?",
                        "description": {
                            "point1": "<strong>Esto cambiará tus metadatos y puede afectar el lanzamiento.</strong>",
                            "point2": "Procede solo si estás completamente seguro.",
                            "point3": "<strong>POR FAVOR NO</strong> edites los metadatos solo para probar y explorar."
                        },
                        "button": {
                            "cancel": "Cancelar",
                            "confirm": "Entiendo"
                        }
                    },
                    "distribute": {
                        "header": "¿Estás seguro de que toda la información ingresada es válida y representa completamente este lanzamiento?",
                        "description": {
                            "point1": "Después de esta acción, tu lanzamiento será revisado y si la información es correcta, será distribuido en las fechas oficiales y exclusivas de distribución.",
                            "point2": "Al confirmar y aceptar este formulario, estás aceptando y cumpliendo completamente con los <1>Términos de Distribución</1>, <3>Términos de Uso</3> y <5>Política de Privacidad</5>.",
                            "point3": "Al confirmar y aceptar este formulario, estás confirmando indiscutiblemente que el contenido del lanzamiento enviado con los activos pertenecientes, archivos de audio y metadatos, te pertenece exclusivamente o está completamente licenciado para tu sello.",
                            "point4": "Por la presente, aceptas completamente que serás el único responsable de cualquier información engañosa, uso no autorizado, actividad ilegal o cualquier tipo de disputa.",
                            "flaggedTracksTerms": {
                                "header": "Términos de Pistas Marcadas",
                                "point1": "Por favor nota: <strong>'{{releaseName}}'</strong> contiene una o más pistas marcadas, se aplica una tarifa de <strong>15 €</strong> por pista marcada para entregar el lanzamiento a <strong>Spotify</strong>. Como has optado por no pagar esta tarifa en este momento, el lanzamiento no se entregará a Spotify. Al confirmar y aceptar este formulario, reconoces y aceptas estos términos.",
                                "point2": "En el futuro, si optas por que el lanzamiento se entregue a <strong>Spotify</strong>, puedes ir a la sección Marcada en la tabla de lanzamientos y seguir las indicaciones de pago."
                            },
                            "artificialStreamingDeclaration": {
                                "header": "Declaración de Streaming Artificial",
                                "point1": "<strong>1.</strong> Entiendo completamente y acepto no participar en ninguna forma de streaming artificial, incluyendo el uso de bots, granjas de streaming o cualquier método que manipule las métricas de DSP.",
                                "point2": "<strong>2.</strong> No pagaré ni ofreceré pago por ubicaciones en listas de reproducción, ni trabajaré con terceros que prometan ubicaciones garantizadas — entiendo que esto se considera fraude y estafa.",
                                "point3": "<strong>3.</strong> Reconozco que tales acciones pueden resultar en la terminación inmediata, pérdida de regalías, reclamaciones legales, penalizaciones contractuales y tarifas, y reporte a DSPs y autoridades.",
                                "point4": "<strong>4.</strong> También garantizo informar y educar a cualquier artista o cliente con el que trabaje sobre estas reglas y asegurarme de que cumplan.",
                                "point5": "<strong>5.</strong> Entiendo que si participo en streaming artificial, mis datos de KYC, incluyendo mi nombre completo, dirección, tarjeta de identificación y otra información personal, pueden ser compartidos con los departamentos legales de los DSP, como los de Spotify, Apple Music y otros.",
                                "point6": "<strong>6.</strong> Acepto la plena responsabilidad legal por cualquier violación.",
                                "acknowledgment": "Por la presente reconozco y acepto cumplir con los términos de Streaming Artificial mencionados anteriormente, y acepto la plena responsabilidad legal por cualquier violación."
                            }
                        },
                        "button": {
                            "cancel": "Cancelar",
                            "confirm": "Confirmar y Aceptar"
                        }
                    },
                    "takedown": {
                        "header": "¿Estás seguro de que deseas eliminar este lanzamiento de todas las tiendas?",
                        "description": {
                            "point1": "Esta acción es irreversible.",
                            "point2": "Al retirar este lanzamiento, estás cumpliendo con los <1>Términos de Distribución</1>, <3>Términos de Uso</3> y <5>Política de Privacidad</5>."
                        },
                        "button": {
                            "cancel": "Cancelar",
                            "confirm": "Confirmar y Aceptar"
                        }
                    },
                    "finishEditing": {
                        "header": "¿Estás seguro de que toda la información ingresada es válida y representa completamente este lanzamiento?",
                        "description": {
                            "point1": "Después de esta acción, tu lanzamiento será revisado y si la información es correcta, será redistribuido a los socios DSP. <strong>NOTA, solo los METADATOS serán enviados a los DSP, el contenido como IMAGEN y archivos de AUDIO no se puede actualizar de esta manera.</strong>",
                            "point2": "Al confirmar y aceptar este formulario, estás aceptando y cumpliendo completamente con los <1>Términos de Uso</1> y los Términos de nuestro Acuerdo de Distribución Exclusiva.",
                            "point3": "Al confirmar y aceptar este formulario, estás aceptando y cumpliendo completamente con la <1>Política de Privacidad</1>.",
                            "point4": "Al confirmar y aceptar este formulario, estás confirmando indiscutiblemente que el contenido del lanzamiento enviado con los activos pertenecientes, archivos de audio y metadatos, te pertenece exclusivamente o está completamente licenciado para tu sello.",
                            "point5": "Por la presente, aceptas completamente que serás el único responsable de cualquier información engañosa, uso no autorizado, actividad ilegal o cualquier tipo de disputa."
                        },
                        "button": {
                            "cancel": "Cancelar",
                            "confirm": "Confirmar y Aceptar"
                        }
                    }
                }
            },
            "message": {
                "success": "¡Lanzamiento actualizado!",
                "declaration_success": "Declaración enviada para revisión del administrador.",
                "declaration_error": "Algo salió mal al enviar la declaración, por favor intenta de nuevo más tarde.",
                "pre_scan_declaration_success": "Declaración del pre-escaneo enviada correctamente.",
                "pre_scan_declaration_error": "Algo salió mal al enviar la declaración del pre-escaneo, por favor intenta de nuevo más tarde.",
                "pre_scan_success": "Lanzamiento enviado correctamente para escaneo.",
                "pre_scan_error": "Algo salió mal al escanear el lanzamiento, por favor intenta de nuevo más tarde.",
                "linkCopied": "¡Enlace copiado al portapapeles!"
            }
        },
        "message": {
            "trackDistributionAllowanceSpent": "Has gastado tu asignación de distribución de pistas. Para subir más pistas, por favor actualiza tu cuenta o contacta a nuestro equipo de soporte.",
            "subscriptionUpgrade": "Tu plan de suscripción actual no admite esta función. Por favor <1>actualiza</1> tu plan de suscripción para aprovechar esta función.",
            "subscriptionExpired": "Tu suscripción ha expirado. Por favor <1>reanuda</1> tu suscripción para aprovechar esta función.",
            "noAccess": "No tienes acceso a este módulo, por favor contacta al equipo de soporte para más información.",
            "subscriptionUpgradeReleaseTransfer": "Tu plan de suscripción actual no admite la función de transferencia de lanzamientos. Si estás transfiriendo un catálogo anterior más grande o deseas transferir más catálogos de sellos discográficos a Music Link con solo unos pocos clics, por favor <1>actualiza</1> tu plan de suscripción.",
            "noAccessReleaseTransfer": "Actualmente, no tienes permiso para usar la función de transferencia de lanzamientos. Si estás transfiriendo un catálogo anterior más grande o deseas transferir más catálogos de sellos discográficos a Music Link con solo unos pocos clics, no dudes en contactar a nuestro equipo de soporte.",
            "accountBlacklisted": "Tu cuenta ha sido blacklisted después de la revisión, como hemos encontrado que la información asociada con tu cuenta está vinculada con uno de los usuarios internacionalmente blacklisted en nuestro sistema. Como resultado, hemos desactivado la funcionalidad de distribución para tu cuenta.",
        }
    },
    "add": {
        "title": "Agregar nuevo lanzamiento",
        "form": {
            "label": {
                "required": "Requerido",
                "name": "Nombre del lanzamiento",
                "version": "Versión del lanzamiento",
                "subuser": "Sub-usuario",
                "label": "Sello",
                "copyright": "Derechos de autor ©",
                "copyright_year": "Año de derechos de autor ©",
                "copyright_publisher": "Derechos de autor ℗",
                "copyright_publisher_year": "Año de derechos de autor ℗",
                "genre": "Género",
                "subgenre": "Subgénero",
                "catalog_number": "Número de catálogo",
                "artwork": "Arte",
                "artwork_alt": "Tu arte",
                "new_release": "¿Es este un nuevo lanzamiento?",
                "original_release_date": "Fecha de lanzamiento original",
                "official_release_date": "Fecha de lanzamiento oficial",
                "backcatalog": "Catálogo anterior",
                "assisted_dates": "Fechas asistidas",
                "exclusive_store_release_date": "Fecha de lanzamiento en tienda exclusiva",
                "additional_metadata": "Metadatos adicionales",
                "release_description": "Descripción del lanzamiento",
                "release_language": "Idioma del nombre del lanzamiento",
                "auto_detect_language": "Detección automática (Idioma)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Generar automáticamente (ean)",
                "territories": "Territorios",
                "countries": "Países",
                "youtube_declaration_header": "DECLARACIÓN DE ID DE CONTENIDO DE YOUTUBE",
                "youtube_declaration_intro": "Para optar por el ID de contenido de YouTube para este lanzamiento, debes asegurarte de cumplir con TODOS los siguientes requisitos:",
                "youtube_declaration_certify": "Yo, <strong>{{firstName}} {{lastName}}</strong>, bajo pena de perjurio, certifico por la presente que la información anterior es verdadera y correcta.",
                "youtube_declaration_point1": "Tengo suficientes derechos sobre el material.",
                "youtube_declaration_point2": "Todo el contenido de referencia es suficientemente distintivo.",
                "youtube_declaration_point3": "Tengo referencias individuales para cada pieza de propiedad intelectual.",
                "youtube_declaration_point4": "El contenido entregado <strong>no</strong> es ninguno de los siguientes: dominio público, contenido con licencia no exclusiva, clips de otras fuentes utilizados bajo principios de uso justo, imágenes de videojuegos (por otros que no sean el editor del juego), grabaciones de karaoke, remasterización sin permiso, grabaciones similares, contenido doblado, aceleración/desaceleración, efectos de sonido, camas de sonido, mezclas continuas de DJ, mashups, listas de cuenta regresiva o cualquier otro contenido prohibido o no elegible mencionado en las Directrices de ID de Contenido de YouTube que se enumeran a continuación.",
                "youtube_declaration_account": "Entiendo que mi cuenta puede ser desactivada y terminada en caso de cualquier violación. Además, entiendo completamente que puedo ser responsable de cualquier tarifa, daños, gastos legales o cualquier otro gasto que pueda acumularse.",
                "youtube_declaration_guidelines": "Según las <1><strong>Directrices de ID de Contenido de YouTube</strong></1>, el contenido enviado a través de este lanzamiento es completamente elegible para el ID de Contenido de YouTube.",
                "youtube_content_id_eligible": "Confirmo que mi contenido es elegible para <strong>ID de Contenido de YouTube</strong>",
                "youtube_content_id_not_eligible": "Mi contenido no es elegible para <strong>ID de Contenido de YouTube</strong>",
                "immersive_audio": "Este lanzamiento tiene audio inmersivo"
            },
            "placeholder": {
                "version": "Deja en blanco si no estás seguro o si este es un lanzamiento regular",
                "select_date": "Seleccionar fecha...",
                "copyright": "Usualmente el nombre de tu sello",
                "copyright_publisher": "Usualmente el nombre de tu sello",
                "copyright_year": "AAAA",
                "copyright_year_publisher": "AAAA",
                "catalog_number": "Inserta tu número de catálogo. Usualmente los sellos insertan la abreviatura del nombre del sello y un número. Ej. {{prefix}}001, {{prefix}}002...",
                "label": "Seleccionar sello...",
                "subuser": "Seleccionar sub-usuario...",
                "genre": "Seleccionar género...",
                "subgenre": "Seleccionar subgénero...",
                "ean": "¡Deja en blanco si no estás seguro!",
                "release_description": "Unas pocas palabras sobre tu lanzamiento. Sin enlaces ni direcciones de correo electrónico, por favor. Máximo 600 caracteres"
            },
            "help_text": {
                "name": "Por favor no uses adiciones al nombre del lanzamiento como LP y EP.",
                "version": "Algunos lanzamientos se publican en más de una versión, si es así, por favor ingresa el nombre de la versión. Si tu lanzamiento es original/estándar, por favor ignora este campo.",
                "subuser": "Nota: Solo usa este menú desplegable si deseas agregar un lanzamiento para cualquiera de tus sub-usuarios, de lo contrario, déjalo sin seleccionar.",
                "label": "Nota: Por favor selecciona tu sello del menú desplegable si ya existe en el sistema, de lo contrario, crea tu sello haciendo clic <1>aquí</1>, una vez creado, puedes seleccionarlo del menú desplegable.",
                "catalog_number": "Inserta tu número de catálogo. Usualmente los sellos insertan la abreviatura del nombre del sello y un número. Ej. {{prefix}}001, {{prefix}}002...",
                "artwork": "Sube formatos JPG, resolución solo 3000x3000 px, @ 72 dpi",
                "original_release_date": "Fecha de lanzamiento original para todas las tiendas en todo el mundo.",
                "official_release_date": "Fecha de lanzamiento oficial para todas las tiendas en todo el mundo.",
                "release_language": "¿En qué idioma está escrito el nombre del lanzamiento? Por favor verifica si no estás seguro. Si esta entrada es incorrecta, algunas tiendas como iTunes y Apple Music rechazarán el lanzamiento.",
                "ean": "El Código Universal de Producto o Número de Artículo Europeo para el lanzamiento. Los códigos válidos son de 13 dígitos. Si no tienes uno propio, generaremos uno para ti."
            },
            "option": {
                "yes": "Sí",
                "no": "No",
                "no_exclusive": "No exclusivo",
                "beatport_2weeks": "Beatport 2 semanas",
                "beatport_4weeks": "Beatport 4 semanas",
                "preorder_1week": "Pre-orden 1 semana",
                "preorder_2weeks": "Pre-orden 2 semanas",
                "traxsource_2weeks": "Traxsource 2 semanas",
                "select": "Seleccionar...",
                "worldwide": "En todo el mundo",
                "only_selected": "Solo países seleccionados",
                "all_except_selected": "Todos excepto los países seleccionados"
            },
            "message": {
                "track_name_required": "Por favor escribe el nombre de la pista",
                "mix_name_required": "Por favor escribe el nombre de la mezcla",
                "mix_name_invalid": "El nombre de la mezcla solo puede consistir en letras, números, espacios y guiones bajos",
                "artist_required": "Por favor selecciona artista",
                "artist_type_required": "Por favor selecciona el tipo de artista",
                "catalog_duplicate": "El número de catálogo '{{number}}' ya fue utilizado. Por favor inserta otro.",
                "ean_duplicate": "Este número EAN está asociado con otro lanzamiento. Por favor inserta otro.",
                "artist_added": "¡Se ha agregado un nuevo artista!",
                "track_limit": "Tu límite actual de pistas es insuficiente. Por favor actualiza tu cuenta o contacta al soporte.",
                "select_day": "Por favor selecciona un día.",
                "form_error": "¡El formulario no puede ser enviado! Por favor llena todos los campos y verifica los errores.",
                "ean_invalid": "El valor no es un EAN válido. Si estás insertando un nuevo lanzamiento, deja este campo en blanco y generaremos un EAN para ti. Si estás subiendo un catálogo anterior y el EAN no es válido, por favor contáctanos.",
                "ean_length": "El número EAN debe ser igual a 13 caracteres",
                "artwork_invalid": "Este archivo es inválido, por favor asegúrate de que la imagen tenga extensión .jpg, colores RGB, dimensiones 3000 X 3000 y hasta 4MB.",
                "track_invalid": "Este archivo es inválido, por favor asegúrate de codificar correctamente tu archivo en 16 bits, 44.1 Khz.",
                "artworkSwapTokenRequiredTooltip": "Tu saldo actual de tokens es insuficiente. Se requiere al menos 1 token para cambiar la portada."
            },
            "button": {
                "reset": "Restablecer",
                "save_only": "Guardar solo",
                "save_and_continue": "Guardar y continuar"
            },
            "modal": {
                "assisted_days": {
                    "header": "¿Estás seguro de que deseas ignorar las mejores prácticas de fecha de lanzamiento?",
                    "body": "Por favor nota que al seleccionar esta opción, tu fecha de lanzamiento podría no ser aceptada por las tiendas o ingerida y publicada en la fecha seleccionada. Además, estás reduciendo fuertemente las oportunidades de marketing.",
                    "button": {
                        "cancel": "Cancelar",
                        "confirm": "Confirmar"
                    }
                },
                "release_created": {
                    "header": "¡Lanzamiento creado!",
                    "body": "¡Tu lanzamiento fue creado exitosamente!",
                    "button": {
                        "close": "Cerrar"
                    }
                }
            }
        }
    },
    "update": {
        "title": "Actualizar lanzamiento",
        "form": {
            "label": {
                "required": "Requerido",
                "name": "Nombre del lanzamiento",
                "version": "Versión del lanzamiento",
                "subuser": "Sub-usuario",
                "label": "Sello",
                "copyright": "Derechos de autor ©",
                "copyright_year": "Año de derechos de autor ©",
                "copyright_publisher": "Derechos de autor ℗",
                "copyright_publisher_year": "Año de derechos de autor ℗",
                "genre": "Género",
                "subgenre": "Subgénero",
                "catalog_number": "Número de catálogo",
                "artwork": "Arte",
                "artwork_alt": "Tu arte",
                "new_release": "¿Es este un nuevo lanzamiento?",
                "original_release_date": "Fecha de lanzamiento original",
                "official_release_date": "Fecha de lanzamiento oficial",
                "backcatalog": "Catálogo anterior",
                "assisted_dates": "Fechas asistidas",
                "exclusive_store_release_date": "Fecha de lanzamiento en tienda exclusiva",
                "additional_metadata": "Metadatos adicionales",
                "release_description": "Descripción del lanzamiento",
                "release_language": "Idioma del nombre del lanzamiento",
                "auto_detect_language": "Detección automática (Idioma)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Generar automáticamente (ean)",
                "territories": "Territorios",
                "countries": "Países",
                "youtube_declaration_header": "DECLARACIÓN DE ID DE CONTENIDO DE YOUTUBE",
                "youtube_declaration_intro": "Para optar por el ID de contenido de YouTube para este lanzamiento, debes asegurarte de cumplir con TODOS los siguientes requisitos:",
                "youtube_declaration_certify": "Yo, <strong>{{firstName}} {{lastName}}</strong>, bajo pena de perjurio, certifico por la presente que la información anterior es verdadera y correcta.",
                "youtube_declaration_point1": "Tengo suficientes derechos sobre el material.",
                "youtube_declaration_point2": "Todo el contenido de referencia es suficientemente distintivo.",
                "youtube_declaration_point3": "Tengo referencias individuales para cada pieza de propiedad intelectual.",
                "youtube_declaration_point4": "El contenido entregado <strong>no</strong> es ninguno de los siguientes: dominio público, contenido con licencia no exclusiva, clips de otras fuentes utilizados bajo principios de uso justo, imágenes de videojuegos (por otros que no sean el editor del juego), grabaciones de karaoke, remasterización sin permiso, grabaciones similares, contenido doblado, aceleración/desaceleración, efectos de sonido, camas de sonido, mezclas continuas de DJ, mashups, listas de cuenta regresiva o cualquier otro contenido prohibido o no elegible mencionado en las Directrices de ID de Contenido de YouTube que se enumeran a continuación.",
                "youtube_declaration_account": "Entiendo que mi cuenta puede ser desactivada y terminada en caso de cualquier violación. Además, entiendo completamente que puedo ser responsable de cualquier tarifa, daños, gastos legales o cualquier otro gasto que pueda acumularse.",
                "youtube_declaration_guidelines": "Según las <1><strong>Directrices de ID de Contenido de YouTube</strong></1>, el contenido enviado a través de este lanzamiento es completamente elegible para el ID de Contenido de YouTube.",
                "youtube_content_id_eligible": "Confirmo que mi contenido es elegible para <strong>ID de Contenido de YouTube</strong>",
                "youtube_content_id_not_eligible": "Mi contenido no es elegible para <strong>ID de Contenido de YouTube</strong>",
                "immersive_audio": "Este lanzamiento tiene audio inmersivo"
            },
            "placeholder": {
                "version": "Deja en blanco si no estás seguro o si este es un lanzamiento regular",
                "select_date": "Seleccionar fecha...",
                "copyright": "Usualmente el nombre de tu sello",
                "copyright_publisher": "Usualmente el nombre de tu sello",
                "copyright_year": "AAAA",
                "copyright_year_publisher": "AAAA",
                "catalog_number": "Inserta tu número de catálogo. Usualmente los sellos insertan la abreviatura del nombre del sello y un número. Ej. {{prefix}}001, {{prefix}}002...",
                "label": "Seleccionar sello...",
                "subuser": "Seleccionar sub-usuario...",
                "genre": "Seleccionar género...",
                "subgenre": "Seleccionar subgénero...",
                "ean": "¡Deja en blanco si no estás seguro!",
                "release_description": "Unas pocas palabras sobre tu lanzamiento. Sin enlaces ni direcciones de correo electrónico, por favor. Máximo 600 caracteres"
            },
            "help_text": {
                "name": "Por favor no uses adiciones al nombre del lanzamiento como LP y EP.",
                "version": "Algunos lanzamientos se publican en más de una versión, si es así, por favor ingresa el nombre de la versión. Si tu lanzamiento es original/estándar, por favor ignora este campo.",
                "subuser": "Nota: Solo usa este menú desplegable si deseas agregar un lanzamiento para cualquiera de tus sub-usuarios, de lo contrario, déjalo sin seleccionar.",
                "label": "Nota: Por favor selecciona tu sello del menú desplegable si ya existe en el sistema, de lo contrario, crea tu sello haciendo clic <1>aquí</1>, una vez creado, puedes seleccionarlo del menú desplegable.",
                "catalog_number": "Inserta tu número de catálogo. Usualmente los sellos insertan la abreviatura del nombre del sello y un número. Ej. {{prefix}}001, {{prefix}}002...",
                "artwork": "Sube formatos JPG, resolución solo 3000x3000 px, @ 72 dpi",
                "original_release_date": "Fecha de lanzamiento original para todas las tiendas en todo el mundo.",
                "official_release_date": "Fecha de lanzamiento oficial para todas las tiendas en todo el mundo.",
                "release_language": "¿En qué idioma está escrito el nombre del lanzamiento? Por favor verifica si no estás seguro. Si esta entrada es incorrecta, algunas tiendas como iTunes y Apple Music rechazarán el lanzamiento.",
                "ean": "El Código Universal de Producto o Número de Artículo Europeo para el lanzamiento. Los códigos válidos son de 13 dígitos. Si no tienes uno propio, generaremos uno para ti."
            },
            "option": {
                "yes": "Sí",
                "no": "No",
                "no_exclusive": "No exclusivo",
                "beatport_2weeks": "Beatport 2 semanas",
                "beatport_4weeks": "Beatport 4 semanas",
                "preorder_1week": "Pre-orden 1 semana",
                "preorder_2weeks": "Pre-orden 2 semanas",
                "traxsource_2weeks": "Traxsource 2 semanas",
                "select": "Seleccionar...",
                "worldwide": "En todo el mundo",
                "only_selected": "Solo países seleccionados",
                "all_except_selected": "Todos excepto los países seleccionados"
            },
            "message": {
                "track_name_required": "Por favor escribe el nombre de la pista",
                "mix_name_required": "Por favor escribe el nombre de la mezcla",
                "mix_name_invalid": "El nombre de la mezcla solo puede consistir en letras, números, espacios y guiones bajos",
                "artist_required": "Por favor selecciona artista",
                "artist_type_required": "Por favor selecciona el tipo de artista",
                "catalog_duplicate": "El número de catálogo '{{number}}' ya fue utilizado. Por favor inserta otro.",
                "ean_duplicate": "Este número EAN está asociado con otro lanzamiento. Por favor inserta otro.",
                "artist_added": "¡Se ha agregado un nuevo artista!",
                "track_limit": "Tu límite actual de pistas es {{trackLimit}} pista(s). Para subir más pistas, por favor actualiza tu cuenta o contacta a nuestro equipo de soporte.",
                "select_day": "Por favor selecciona un día.",
                "form_error": "¡El formulario no puede ser enviado! Por favor llena todos los campos y verifica los errores.",
                "ean_invalid": "El valor no es un EAN válido. Si estás insertando un nuevo lanzamiento, deja este campo en blanco y generaremos un EAN para ti. Si estás subiendo un catálogo anterior y el EAN no es válido, por favor contáctanos.",
                "ean_length": "El número EAN debe ser igual a 13 caracteres",
                "artwork_invalid": "Este archivo es inválido, por favor asegúrate de que la imagen tenga extensión .jpg, colores RGB, dimensiones 3000 X 3000 y hasta 4MB.",
                "track_invalid": "Este archivo es inválido, por favor asegúrate de codificar correctamente tu archivo en 16 bits, 44.1 Khz."
            },
            "button": {
                "reset": "Restablecer",
                "submit_form": "Enviar formulario",
                "save_and_continue": "Guardar y continuar"
            },
            "modal": {
                "assisted_days": {
                    "header": "¿Estás seguro de que deseas ignorar las mejores prácticas de fecha de lanzamiento?",
                    "body": "Por favor nota que al seleccionar esta opción, tu fecha de lanzamiento podría no ser aceptada por las tiendas o ingerida y publicada en la fecha seleccionada. Además, estás reduciendo fuertemente las oportunidades de marketing.",
                    "button": {
                        "cancel": "Cancelar",
                        "confirm": "Confirmar"
                    }
                },
                "release_updated": {
                    "header": "¡Lanzamiento actualizado!",
                    "body": "¡Tu lanzamiento fue actualizado exitosamente!",
                    "button": {
                        "close": "Cerrar"
                    }
                }
            }
        }
    },
    "transfer": {
        "title": "Transferir lanzamiento",
        "view": {
            "title": "Transferir lanzamiento",
            "label": {
                "searchBy": "Buscar por",
                "upc": "Número UPC",
                "url": "URL de lanzamiento en tienda",
                "name": "Nombre del lanzamiento",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "fetchReleaseDetails": "Obteniendo detalles del lanzamiento..."
            },
            "placeholder": {
                "upc": "Ingresa el número UPC/EAN del lanzamiento, ej. 5055964352523",
                "url": "Ingresa la URL del lanzamiento en tienda, ej. open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn o www.deezer.com/en/album/413370367",
                "name": "Ingresa el nombre del lanzamiento, ej. Warrior"
            },
            "help_text": {
                "upc": "Nota: Solo usa este menú desplegable si deseas agregar un lanzamiento que ya está en Spotify o Deezer.",
                "url": "Nota: Solo usa este menú desplegable si deseas agregar un lanzamiento que ya está en Spotify o Deezer.",
                "name_spotify": "Nota: Solo usa este menú desplegable si deseas agregar un lanzamiento que ya está en Spotify.",
                "name_deezer": "Nota: Solo usa este menú desplegable si deseas agregar un lanzamiento que ya está en Deezer."
            },
            "button": {
                "reset": "Restablecer",
                "transfer": "Transferir"
            },
            "message": {
                "release_exists": "Un lanzamiento con este número UPC ya pertenece a otro usuario dentro de la plataforma Music Link. Por favor importa solo lanzamientos que pertenezcan completamente a tu empresa y sello. Si crees que alguien tomó tu lanzamiento sin permiso, por favor ponte en contacto con nuestro equipo de soporte."
            }
        },
        "modal": {
            "header": "Términos de transferencia de lanzamiento",
            "ownership_warranty": {
                "header": "Garantía de propiedad",
                "body": {
                    "point1": "Al aceptar estos términos, reconoces y garantizas que tienes la propiedad legal o representas al propietario legítimo de todo el contenido, incluido el lanzamiento y las canciones asociadas, proporcionadas aquí.",
                    "point2": "Afirmas que no se incorpora en este lanzamiento ningún material con derechos de autor o propiedad intelectual perteneciente a un tercero."
                }
            },
            "non_infringement_warranty": {
                "header": "Garantía de no infracción",
                "body": {
                    "point1": "Al proceder, confirmas expresamente que el contenido enviado en este lanzamiento no infringe los derechos de terceros, incluidos, entre otros, derechos de autor, marcas comerciales u otros derechos de propiedad.",
                    "point2": "Aceptas no incluir ningún material de fuentes externas sin la debida autorización."
                }
            },
            "exclusivity_declaration": {
                "header": "Declaración de exclusividad",
                "body": {
                    "point1": "Al consentir estos términos, te comprometes a que el contenido presentado en este lanzamiento es exclusivo de tu propiedad o representación autorizada, y no ha sido ofrecido o lanzado a ninguna otra entidad o plataforma.",
                    "point2": "Asumes la plena responsabilidad por cualquier incumplimiento de exclusividad y entiendes que cualquier violación de este tipo puede conllevar consecuencias legales."
                }
            },
            "legal_consequences_awareness": {
                "header": "Conciencia de consecuencias legales",
                "body": {
                    "point1": "Es crucial comprender que cualquier incumplimiento de los términos y garantías descritos en este modal o términos puede conllevar graves repercusiones legales.",
                    "point2": "Estas penalidades podrían incluir, entre otras, responsabilidades financieras sustanciales, medidas cautelares legales y daño a la reputación.",
                    "point3": "Al aceptar estos términos, reconoces la seriedad de cumplir con las obligaciones establecidas y reconoces que el incumplimiento puede resultar en acciones legales contra ti o tu organización."
                }
            },
            "button": {
                "cancel": "Cancelar",
                "agree": "Estoy de acuerdo"
            }
        },
        "form": {
            "title": "Transferir lanzamiento",
            "label": {
                "required": "Requerido",
                "name": "Nombre del lanzamiento",
                "version": "Versión del lanzamiento",
                "subuser": "Sub-usuario",
                "label": "Sello",
                "copyright": "Derechos de autor ©",
                "copyright_year": "Año de derechos de autor ©",
                "copyright_publisher": "Derechos de autor ℗",
                "copyright_publisher_year": "Año de derechos de autor ℗",
                "genre": "Género",
                "subgenre": "Subgénero",
                "catalog_number": "Número de catálogo",
                "artwork": "Arte",
                "artwork_alt": "Tu arte",
                "new_release": "¿Es este un nuevo lanzamiento?",
                "original_release_date": "Fecha de lanzamiento original",
                "official_release_date": "Fecha de lanzamiento oficial",
                "backcatalog": "Catálogo anterior",
                "assisted_dates": "Fechas asistidas",
                "exclusive_store_release_date": "Fecha de lanzamiento en tienda exclusiva",
                "additional_metadata": "Metadatos adicionales",
                "release_description": "Descripción del lanzamiento",
                "release_language": "Idioma del nombre del lanzamiento",
                "auto_detect_language": "Detección automática (Idioma)",
                "ean": "EAN / UPC",
                "territories": "Territorios",
                "countries": "Países",
                "youtube_declaration_header": "DECLARACIÓN DE ID DE CONTENIDO DE YOUTUBE",
                "youtube_declaration_intro": "Para optar por el ID de contenido de YouTube para este lanzamiento, debes asegurarte de cumplir con TODOS los siguientes requisitos:",
                "youtube_declaration_certify": "Yo, <strong>{{firstName}} {{lastName}}</strong>, bajo pena de perjurio, certifico por la presente que la información anterior es verdadera y correcta.",
                "youtube_declaration_point1": "Tengo suficientes derechos sobre el material.",
                "youtube_declaration_point2": "Todo el contenido de referencia es suficientemente distintivo.",
                "youtube_declaration_point3": "Tengo referencias individuales para cada pieza de propiedad intelectual.",
                "youtube_declaration_point4": "El contenido entregado <strong>no</strong> es ninguno de los siguientes: dominio público, contenido con licencia no exclusiva, clips de otras fuentes utilizados bajo principios de uso justo, imágenes de videojuegos (por otros que no sean el editor del juego), grabaciones de karaoke, remasterización sin permiso, grabaciones similares, contenido doblado, aceleración/desaceleración, efectos de sonido, camas de sonido, mezclas continuas de DJ, mashups, listas de cuenta regresiva o cualquier otro contenido prohibido o no elegible mencionado en las Directrices de ID de Contenido de YouTube que se enumeran a continuación.",
                "youtube_declaration_account": "Entiendo que mi cuenta puede ser desactivada y terminada en caso de cualquier violación. Además, entiendo completamente que puedo ser responsable de cualquier tarifa, daños, gastos legales o cualquier otro gasto que pueda acumularse.",
                "youtube_declaration_guidelines": "Según las <1><strong>Directrices de ID de Contenido de YouTube</strong></1>, el contenido enviado a través de este lanzamiento es completamente elegible para el ID de Contenido de YouTube.",
                "youtube_content_id_eligible": "Confirmo que mi contenido es elegible para <strong>ID de Contenido de YouTube</strong>",
                "youtube_content_id_not_eligible": "Mi contenido no es elegible para <strong>ID de Contenido de YouTube</strong>",
                "immersive_audio": "Este lanzamiento tiene audio inmersivo"
            },
            "placeholder": {
                "version": "Deja en blanco si no estás seguro o si este es un lanzamiento regular",
                "select_date": "Seleccionar fecha...",
                "copyright": "Usualmente el nombre de tu sello",
                "copyright_publisher": "Usualmente el nombre de tu sello",
                "copyright_year": "AAAA",
                "copyright_year_publisher": "AAAA",
                "catalog_number": "Inserta tu número de catálogo. Usualmente los sellos insertan la abreviatura del nombre del sello y un número. Ej. {{prefix}}001, {{prefix}}002...",
                "label": "Seleccionar sello...",
                "subuser": "Seleccionar sub-usuario...",
                "genre": "Seleccionar género...",
                "subgenre": "Seleccionar subgénero...",
                "ean": "¡Deja en blanco si no estás seguro!",
                "release_description": "Unas pocas palabras sobre tu lanzamiento. Sin enlaces ni direcciones de correo electrónico, por favor. Máximo 600 caracteres"
            },
            "help_text": {
                "name": "Por favor no uses adiciones al nombre del lanzamiento como LP y EP.",
                "version": "Algunos lanzamientos se publican en más de una versión, si es así, por favor ingresa el nombre de la versión. Si tu lanzamiento es original/estándar, por favor ignora este campo.",
                "subuser": "Nota: Solo usa este menú desplegable si deseas agregar un lanzamiento para cualquiera de tus sub-usuarios, de lo contrario, déjalo sin seleccionar.",
                "label": "Nota: Por favor selecciona tu sello <strong>{{labelName}}</strong> del menú desplegable si ya existe en el sistema, de lo contrario, crea tu sello <strong>{{labelName}}</strong> haciendo clic <5>aquí</5>, una vez creado, puedes seleccionarlo del menú desplegable.",
                "catalog_number": "Inserta tu número de catálogo. Usualmente los sellos insertan la abreviatura del nombre del sello y un número. Ej. {{prefix}}001, {{prefix}}002...",
                "artwork": "Sube formatos JPG, resolución solo 3000x3000 px, @ 72 dpi",
                "original_release_date": "Fecha de lanzamiento original para todas las tiendas en todo el mundo.",
                "official_release_date": "Fecha de lanzamiento oficial para todas las tiendas en todo el mundo.",
                "release_language": "¿En qué idioma está escrito el nombre del lanzamiento? Por favor verifica si no estás seguro. Si esta entrada es incorrecta, algunas tiendas como iTunes y Apple Music rechazarán el lanzamiento.",
                "ean": "El Código Universal de Producto o Número de Artículo Europeo para el lanzamiento. Los códigos válidos son de 13 dígitos. Si no tienes uno propio, generaremos uno para ti."
            },
            "option": {
                "yes": "Sí",
                "no": "No",
                "no_exclusive": "No exclusivo",
                "beatport_2weeks": "Beatport 2 semanas",
                "beatport_4weeks": "Beatport 4 semanas",
                "preorder_1week": "Pre-orden 1 semana",
                "preorder_2weeks": "Pre-orden 2 semanas",
                "traxsource_2weeks": "Traxsource 2 semanas",
                "select": "Seleccionar...",
                "worldwide": "En todo el mundo",
                "only_selected": "Solo países seleccionados",
                "all_except_selected": "Todos excepto los países seleccionados"
            },
            "message": {
                "track_name_required": "Por favor escribe el nombre de la pista",
                "mix_name_required": "Por favor escribe el nombre de la mezcla",
                "mix_name_invalid": "El nombre de la mezcla solo puede consistir en letras, números, espacios y guiones bajos",
                "artist_required": "Por favor selecciona artista",
                "artist_type_required": "Por favor selecciona el tipo de artista",
                "catalog_duplicate": "El número de catálogo '{{number}}' ya fue utilizado. Por favor inserta otro.",
                "artist_added": "¡Se ha agregado un nuevo artista!",
                "track_limit": "Tu límite actual de pistas es {{trackLimit}} pista(s). Para subir más pistas, por favor actualiza tu cuenta o contacta a nuestro equipo de soporte.",
                "select_day": "Por favor selecciona un día.",
                "form_error": "¡El formulario no puede ser enviado! Por favor llena todos los campos y verifica los errores.",
                "ean_invalid": "El valor no es un EAN válido. Si estás insertando un nuevo lanzamiento, deja este campo en blanco y generaremos un EAN para ti. Si estás subiendo un catálogo anterior y el EAN no es válido, por favor contáctanos.",
                "ean_length": "El número EAN debe ser igual a 13 caracteres",
                "artwork_invalid": "Este archivo es inválido, por favor asegúrate de que la imagen tenga extensión .jpg, colores RGB, dimensiones 3000 X 3000 y hasta 4MB.",
                "track_invalid": "Este archivo es inválido, por favor asegúrate de codificar correctamente tu archivo en 16 bits, 44.1 Khz."
            },
            "button": {
                "reset": "Restablecer",
                "save_only": "Guardar solo",
                "save_and_continue": "Guardar y continuar"
            },
            "modal": {
                "assisted_days": {
                    "header": "¿Estás seguro de que deseas ignorar las mejores prácticas de fecha de lanzamiento?",
                    "body": "Por favor nota que al seleccionar esta opción, tu fecha de lanzamiento podría no ser aceptada por las tiendas o ingerida y publicada en la fecha seleccionada. Además, estás reduciendo fuertemente las oportunidades de marketing.",
                    "button": {
                        "cancel": "Cancelar",
                        "confirm": "Confirmar"
                    }
                },
                "release_created": {
                    "header": "¡Lanzamiento creado!",
                    "body": "¡Tu lanzamiento fue creado exitosamente!",
                    "button": {
                        "close": "Cerrar"
                    }
                },
                "release_transfer_declaration": {
                    "header": "Declaración de transferencia de lanzamiento",
                    "body": "He revisado y completado toda la información necesaria para este lanzamiento y ahora está listo para SUBIR.",
                    "button": {
                        "cancel": "Cancelar",
                        "confirm": "Confirmar"
                    }
                }
            }
        }
    },
    "viewDetails": {
        "title": "Ver lanzamiento",
        "form": {
            "label": {
                "required": "Requerido",
                "name": "Nombre del lanzamiento",
                "version": "Versión del lanzamiento",
                "subuser": "Sub-usuario",
                "label": "Sello",
                "copyright": "Derechos de autor ©",
                "copyright_year": "Año de derechos de autor ©",
                "copyright_publisher": "Derechos de autor ℗",
                "copyright_publisher_year": "Año de derechos de autor ℗",
                "genre": "Género",
                "subgenre": "Subgénero",
                "catalog_number": "Número de catálogo",
                "artwork": "Arte",
                "artwork_alt": "Tu arte",
                "new_release": "¿Es este un nuevo lanzamiento?",
                "original_release_date": "Fecha de lanzamiento original",
                "official_release_date": "Fecha de lanzamiento oficial",
                "backcatalog": "Catálogo anterior",
                "assisted_dates": "Fechas asistidas",
                "exclusive_store_release_date": "Fecha de lanzamiento en tienda exclusiva",
                "additional_metadata": "Metadatos adicionales",
                "release_description": "Descripción del lanzamiento",
                "release_language": "Idioma del nombre del lanzamiento",
                "auto_detect_language": "Detección automática (Idioma)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Generar automáticamente (ean)",
                "territories": "Territorios",
                "countries": "Países",
                "youtube_declaration_header": "DECLARACIÓN DE ID DE CONTENIDO DE YOUTUBE",
                "youtube_declaration_intro": "Para optar por el ID de contenido de YouTube para este lanzamiento, debes asegurarte de cumplir con TODOS los siguientes requisitos:",
                "youtube_declaration_certify": "Yo, <strong>{{firstName}} {{lastName}}</strong>, bajo pena de perjurio, certifico por la presente que la información anterior es verdadera y correcta.",
                "youtube_declaration_point1": "Tengo suficientes derechos sobre el material.",
                "youtube_declaration_point2": "Todo el contenido de referencia es suficientemente distintivo.",
                "youtube_declaration_point3": "Tengo referencias individuales para cada pieza de propiedad intelectual.",
                "youtube_declaration_point4": "El contenido entregado <strong>no</strong> es ninguno de los siguientes: dominio público, contenido con licencia no exclusiva, clips de otras fuentes utilizados bajo principios de uso justo, imágenes de videojuegos (por otros que no sean el editor del juego), grabaciones de karaoke, remasterización sin permiso, grabaciones similares, contenido doblado, aceleración/desaceleración, efectos de sonido, camas de sonido, mezclas continuas de DJ, mashups, listas de cuenta regresiva o cualquier otro contenido prohibido o no elegible mencionado en las Directrices de ID de Contenido de YouTube que se enumeran a continuación.",
                "youtube_declaration_account": "Entiendo que mi cuenta puede ser desactivada y terminada en caso de cualquier violación. Además, entiendo completamente que puedo ser responsable de cualquier tarifa, daños, gastos legales o cualquier otro gasto que pueda acumularse.",
                "youtube_declaration_guidelines": "Según las <1><strong>Directrices de ID de Contenido de YouTube</strong></1>, el contenido enviado a través de este lanzamiento es completamente elegible para el ID de Contenido de YouTube.",
                "youtube_content_id_eligible": "Confirmo que mi contenido es elegible para <strong>ID de Contenido de YouTube</strong>",
                "youtube_content_id_not_eligible": "Mi contenido no es elegible para <strong>ID de Contenido de YouTube</strong>",
                "immersive_audio": "Este lanzamiento tiene audio inmersivo"
            },
            "placeholder": {
                "version": "Deja en blanco si no estás seguro o si este es un lanzamiento regular",
                "select_date": "Seleccionar fecha...",
                "copyright": "Usualmente el nombre de tu sello",
                "copyright_publisher": "Usualmente el nombre de tu sello",
                "copyright_year": "AAAA",
                "copyright_year_publisher": "AAAA",
                "catalog_number": "Inserta tu número de catálogo. Usualmente los sellos insertan la abreviatura del nombre del sello y un número. Ej. {{prefix}}001, {{prefix}}002...",
                "label": "Seleccionar sello...",
                "subuser": "Seleccionar sub-usuario...",
                "artist": "Seleccionar artista...",
                "genre": "Seleccionar género...",
                "subgenre": "Seleccionar subgénero...",
                "ean": "¡Deja en blanco si no estás seguro!",
                "release_description": "Unas pocas palabras sobre tu lanzamiento. Sin enlaces ni direcciones de correo electrónico, por favor. Máximo 600 caracteres"
            },
            "help_text": {
                "name": "Por favor no uses adiciones al nombre del lanzamiento como LP y EP.",
                "version": "Algunos lanzamientos se publican en más de una versión, si es así, por favor ingresa el nombre de la versión. Si tu lanzamiento es original/estándar, por favor ignora este campo.",
                "subuser": "Nota: Solo usa este menú desplegable si deseas agregar un lanzamiento para cualquiera de tus sub-usuarios, de lo contrario, déjalo sin seleccionar.",
                "catalog_number": "Inserta tu número de catálogo. Usualmente los sellos insertan la abreviatura del nombre del sello y un número. Ej. {{prefix}}001, {{prefix}}002...",
                "artwork": "Sube formatos JPG, resolución solo 3000x3000 px, @ 72 dpi",
                "original_release_date": "Fecha de lanzamiento original para todas las tiendas en todo el mundo.",
                "official_release_date": "Fecha de lanzamiento oficial para todas las tiendas en todo el mundo.",
                "release_language": "¿En qué idioma está escrito el nombre del lanzamiento? Por favor verifica si no estás seguro. Si esta entrada es incorrecta, algunas tiendas como iTunes y Apple Music rechazarán el lanzamiento.",
                "ean": "El Código Universal de Producto o Número de Artículo Europeo para el lanzamiento. Los códigos válidos son de 13 dígitos. Si no tienes uno propio, generaremos uno para ti."
            },
            "option": {
                "yes": "Sí",
                "no": "No",
                "no_exclusive": "No exclusivo",
                "beatport_2weeks": "Beatport 2 semanas",
                "beatport_4weeks": "Beatport 4 semanas",
                "preorder_1week": "Pre-orden 1 semana",
                "preorder_2weeks": "Pre-orden 2 semanas",
                "traxsource_2weeks": "Traxsource 2 semanas",
                "select": "Seleccionar...",
                "worldwide": "En todo el mundo",
                "only_selected": "Solo países seleccionados",
                "all_except_selected": "Todos excepto los países seleccionados"
            },
            "message": {
                "track_name_required": "Por favor escribe el nombre de la pista",
                "mix_name_required": "Por favor escribe el nombre de la mezcla",
                "mix_name_invalid": "El nombre de la mezcla solo puede consistir en letras, números, espacios y guiones bajos",
                "artist_required": "Por favor selecciona artista",
                "artist_type_required": "Por favor selecciona el tipo de artista",
                "catalog_duplicate": "El número de catálogo '{{number}}' ya fue utilizado. Por favor inserta otro.",
                "artist_added": "¡Se ha agregado un nuevo artista!",
                "track_limit": "Tu límite actual de pistas es {{trackLimit}} pista(s). Para subir más pistas, por favor actualiza tu cuenta o contacta a nuestro equipo de soporte.",
                "select_day": "Por favor selecciona un día.",
                "form_error": "¡El formulario no puede ser enviado! Por favor llena todos los campos y verifica los errores.",
                "ean_invalid": "El valor no es un EAN válido. Si estás insertando un nuevo lanzamiento, deja este campo en blanco y generaremos un EAN para ti. Si estás subiendo un catálogo anterior y el EAN no es válido, por favor contáctanos.",
                "ean_length": "El número EAN debe ser igual a 13 caracteres",
                "artwork_invalid": "Este archivo es inválido, por favor asegúrate de que la imagen tenga extensión .jpg, colores RGB, dimensiones 3000 X 3000 y hasta 4MB.",
                "track_invalid": "Este archivo es inválido, por favor asegúrate de codificar correctamente tu archivo en 16 bits, 44.1 Khz."
            },
            "button": {
                "submit": "Enviar formulario"
            },
            "modal": {
                "assisted_days": {
                    "header": "¿Estás seguro de que deseas ignorar las mejores prácticas de fecha de lanzamiento?",
                    "body": "Por favor nota que al seleccionar esta opción, tu fecha de lanzamiento podría no ser aceptada por las tiendas o ingerida y publicada en la fecha seleccionada. Además, estás reduciendo fuertemente las oportunidades de marketing.",
                    "button": {
                        "cancel": "Cancelar",
                        "confirm": "Confirmar"
                    }
                },
                "release_updated": {
                    "header": "¡Lanzamiento actualizado!",
                    "body": "¡Tu lanzamiento fue actualizado exitosamente!",
                    "button": {
                        "close": "Cerrar"
                    }
                }
            }
        }
    },
    "artists_row": {
        "artistType": {
            "main": "Artista principal",
            "featuring": "Artista invitado",
            "remixer": "Remixer"
        },
        "placeholder": {
            "selectArtist": "Seleccionar artista..."
        },
        "button": {
            "remove": "Eliminar",
            "addAnother": "Agregar otro",
            "createNew": "¿Crear nuevo?"
        },
        "modal": {
            "header": "¿Estás seguro de que deseas asignar este artista como Artista Invitado?",
            "body": "Por favor no confundas Artista Invitado con un Remixer. El Artista Invitado solo debe agregarse si estás seguro de que este artista no es el Artista Principal o Remixer.",
            "cancel": "Cancelar",
            "confirm": "Confirmar"
        },
        "label": {
            "order": "Orden",
            "artistName": "Nombre del artista",
            "artistType": "Tipo de artista",
            "artists": "Artistas",
            "required": "Requerido"
        },
        "help_text": {
            "artists": "Si el lanzamiento está escrito por más de <strong>4 Artistas Principales</strong> por favor usa <strong>Varios Artistas</strong>. Los artistas de pista, remixers y colaboradores deben agregarse en el paso de Edición de Pista."
        }
    },
    "tracks_row": {
        "label": {
            "tracks": "Pistas",
            "order": "Orden",
            "trackName": "Nombre de la pista",
            "mixName": "Nombre de la mezcla",
            "file": "Archivo",
            "albumOnly": "Solo álbum",
            "required": "Requerido",
            "stereo": "Estéreo",
            "dolbyAtmos": "Dolby Atmos",
            "addAnother": "Agregar otro",
            "remove": "¿Eliminar?",
            "onlyAlbum": "Solo álbum",
            "mixTypes": {
                "originalMix": "Mezcla original",
                "remixOrMix": "Esto es un Remix o Mezcla"
            }
        },
        "button": {
            "remove": "Eliminar",
            "addAnother": "Agregar otro"
        },
        "validation": {
            "trackName": "Por favor escribe el nombre de la pista",
            "mixName": "Por favor escribe el nombre de la mezcla",
            "mixNameRegex": "El nombre de la mezcla solo puede consistir en letras, números, espacios y guiones bajos",
            "trackFile": "Por favor selecciona el archivo de la pista",
            "trackFileDolby": "Por favor selecciona el archivo de dolby atmos de la pista",
            "trackFileDuration": "La duración de los archivos de pista estéreo y dolby debe coincidir",
            "swapTrackAudioTokenRequiredTooltip": "Tu saldo actual de tokens es insuficiente. Se requiere al menos 1 token para cambiar el audio de la pista."
        }
    },
    "transfer_artists_row": {
        "label": {
            "artists": "Artistas",
            "order": "Orden",
            "artistName": "Nombre del artista",
            "artistType": "Tipo de artista",
            "required": "Requerido"
        },
        "placeholder": {
            "selectArtist": "Seleccionar artista..."
        },
        "help_text": {
            "artists": "Si el lanzamiento está escrito por más de <strong>4 Artistas Principales</strong> por favor usa <strong>Varios Artistas</strong>. Los artistas de pista, remixers y colaboradores deben agregarse en el paso de Edición de Pista."
        },
        "option": {
            "artistType": {
                "main": "Artista principal",
                "featuring": "Artista invitado",
                "remixer": "Remixer"
            }
        },
        "button": {
            "remove": "Eliminar",
            "addAnother": "Agregar otro",
            "createNew": "¿Crear nuevo?"
        },
        "message": {
            "errorArtistRequired": "Por favor selecciona artista",
            "errorArtistTypeRequired": "Por favor selecciona el tipo de artista"
        },
        "modal": {
            "header": "¿Estás seguro de que deseas asignar este artista como Artista Invitado?",
            "body": "Por favor no confundas Artista Invitado con un Remixer. El Artista Invitado solo debe agregarse si estás seguro de que este artista no es el Artista Principal o Remixer.",
            "button": {
                "cancel": "Cancelar",
                "confirm": "Confirmar"
            }
        }
    },
    "store_picker": {
        "label": {
            "stores": "Tiendas"
        },
        "placeholder": {
            "search": "Buscar tienda..."
        },
        "section": {
            "mandatory": "Obligatorio",
            "optional": "Opcional",
            "optional_locked": "Opcional Tiendas Adicionales",
            "summary": {
                "read_only": "{{title}} ({{count}} en total)",
                "editable": "{{title}} ({{total}} en total, {{selected}} seleccionados)"
            }
        },
        "message": {
            "no_stores": "No se encontraron tiendas.",
            "availability": "Beatport solo está disponible para lanzamientos de Dance con sellos aprobados por Beatport. Traxsource solo está disponible para lanzamientos de Dance con sellos aprobados por Traxsource.",
            "youtube_declaration": "Por favor, firma primero la Declaración de YouTube Content ID.",
            "youtube_ineligible": "Esta tienda no es elegible ya que has indicado que no tienes los derechos de propiedad. Si se declara falsamente, podrías ser responsable de una disputa legal.",
            "youtube_content_id": "Esta tienda no aplica para lanzamientos elegibles para YouTube Content ID porque se entrega tanto a YouTube Content ID como a YouTube Premium.",
            "beatport": "Beatport solo se puede seleccionar cuando el género es Dance y el sello está aprobado para Beatport.",
            "traxsource": "Traxsource solo se puede seleccionar cuando el género es Dance y el sello está aprobado para Traxsource.",
            "juno": "JunoDownload solo se puede seleccionar cuando el género es Dance.",
            "contact_support": "Por favor contacta a nuestro equipo de soporte para desbloquear esas tiendas.",
            "optional_additional_none_selected": "No has seleccionado ninguna Tienda Adicional Opcional. Estas pueden ampliar tu alcance. ¿Seguro que quieres omitirlas?",
            "optional_paid_insufficient_tokens": "Saldo de tokens insuficiente. Se requiere al menos 1 token para seleccionar Tiendas Adicionales Opcionales.",
            "optional_paid_insufficient_tokens_with_link": "Tu saldo actual de tokens es insuficiente. Se requiere al menos 1 token para seleccionar Tiendas Adicionales Opcionales. <2>Pedir tokens</2> para continuar."
        }
    },
    "transfer_tracks_row": {
        "label": {
            "tracks": "Pistas",
            "order": "Orden",
            "trackName": "Nombre de la pista",
            "mixName": "Nombre de la mezcla",
            "file": "Archivo",
            "albumOnly": "Solo álbum",
            "required": "Requerido",
            "stereo": "Estéreo",
            "dolbyAtmos": "Dolby Atmos",
            "addAnother": "Agregar otro",
            "remove": "¿Eliminar?",
            "onlyAlbum": "Solo álbum",
            "mixTypes": {
                "originalMix": "Mezcla original",
                "remixOrMix": "Esto es un Remix o Mezcla"
            }
        },
        "button": {
            "remove": "Eliminar",
            "addAnother": "Agregar otro"
        },
        "validation": {
            "trackName": "Por favor escribe el nombre de la pista",
            "mixName": "Por favor escribe el nombre de la mezcla",
            "mixNameRegex": "El nombre de la mezcla solo puede consistir en letras, números, espacios y guiones bajos",
            "trackFile": "Por favor selecciona el archivo de la pista",
            "trackFileDolby": "Por favor selecciona el archivo de dolby atmos de la pista",
            "trackFileDuration": "La duración de los archivos de pista estéreo y dolby debe coincidir"
        }
    }
};

export default releasesES;